import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  getAllUserAvatar () {
    return Vue.http.get(urls.USER_AVATAR, {'headers': authHeaders.getAuthHeaders()})
  },
  createUserAvatar (userAvatar) {
    let body = JSON.stringify(userAvatar)
    return Vue.http.post(urls.USER_AVATAR, body, {'headers': authHeaders.getAuthHeaders()})
  },
  updateUserAvatar (userAvatar) {
    let body = JSON.stringify(userAvatar)
    let target = urls.USER_AVATAR + userAvatar.id + '/'
    return Vue.http.patch(target, body, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/user-avatar.api.js